












import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import skyconText from '@/utils/skyconText'
export default Vue.extend({
    props: ['longitude', 'latitude'],
    computed: {
        lngLat(): any {
            const { longitude, latitude } = this
            return { longitude, latitude }
        },
    },
    watch: {
        lngLat() {
            this.getData()
        },
    },
    data() {
        return {
            data: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            const url = `/v2.5/Qu1kUDHidwJHZoNF/${this.lngLat.longitude},${this.lngLat.latitude}/daily`
            request.get(url).then((result) => {
                // console.log(result.result.daily)
                const tempData = result.result.daily.temperature
                const skycon = result.result.daily.skycon
                const daysData = skycon.map((e: any) => {
                    return {
                        imgUrl: `/static/weatherIcon/${e.value}.png`,
                        date: e.date.split('T')[0].split('-').slice(1, 3).join('/'),
                    }
                })
                daysData.map((e: any) => {
                    tempData.map((k: any) => {
                        if (e.date === k.date.split('T')[0].split('-').slice(1, 3).join('/')) {
                            e.min = (k.min).toFixed(0)
                            e.max = (k.max).toFixed(0)
                        }
                    })
                })
                // console.log(daysData)
                this.data = daysData
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
    },
})
